import { renderToStaticMarkup } from "react-dom/server";
import * as L from "leaflet";
import { MapMarkerIcon } from "src/components/icons/MapMarkerIcon";

export type PoiMarkerStatus = "default" | "active" | "new";

export function getLeafletMarker(
  latlng: L.LatLngLiteral,
  status: PoiMarkerStatus,
  options?: L.MarkerOptions | undefined
) {
  const icon = getLeafletMarkerIcon(status);
  const marker = L.marker(latlng, {
    icon,
    ...options,
  });
  return marker;
}

export function getLeafletMarkerIcon(status: PoiMarkerStatus) {
  function defineColor(status: string) {
    switch (status) {
      case "default":
        return "#3fabff";
      case "active":
        return "#E2646B";
      case "new":
        return "grey";
    }
  }
  return new L.DivIcon({
    html: renderToStaticMarkup(<MapMarkerIcon color={defineColor(status)} />),
    iconSize: [33, 44],
    iconAnchor: [33 / 2, 44],
  });
}
